import { render } from "./OurJourney.vue?vue&type=template&id=05a6ab84"
import script from "./OurJourney.vue?vue&type=script&lang=js"
export * from "./OurJourney.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__